import axios from "../axiosPlugin.js";

export const getDepartment = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/group/list",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const getConcessionType = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/concessionType/list",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const getSalesGroup = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/salesGroup/list",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const createConcessionType = (data, loading = true) => {
  return axios({
    url: "/api/concessionType/create",
    method: "post",
    data: {
      data,
      loading,
    },
  });
};

export const updateConcessionType = (data, loading = true) => {
  return axios({
    url: "/api/concessionType/update",
    method: "put",
    data: {
      data,
      loading,
    },
  });
};

export const deleteConcessionType = (data, loading = true) => {
  return axios({
    url: "/api/concessionType/delete/" + data.id,
    method: "delete",
    data: {
      data,
      loading,
    },
  });
};

export const updateInventory = (data, loading = true) => {
  return axios({
    url: "/api/concessionType/updateInventory?" + data,
    method: "post",
    data: {
      // data,
      loading,
    },
  });
};

export const approveConcessionType = data => {
  return axios({
    url: `/api/concessionType/approve?cinemaId=${data.cinemaId}`,
    method: "post",
    data: {
      data,
    },
  });
};

export const inventoryExport = data => {
  let queryString = `cinemaId=${data.cinemaId}&page=${data.page}&pageSize=${data.pageSize}`;

  return axios({
    url: "/api/concessionType/inventoryExport?" + queryString,
    method: "get",
    data: {
      data: {
        isDownladFile: true,
      }
    },
  });
};

export const concessionTypeExport = data => {
  let queryString = `name=${data.name}&cinemaId=${data.cinemaId}&page=${data.page}&pageSize=${data.pageSize}`;

  data.groupIds.forEach(id => {
    queryString = queryString + "&groupIds=" + id;
  });

  return axios({
    url: "/api/concessionType/export?" + queryString,
    method: "get",
    data: {
      data: {
        isDownladFile: true,
      }
    },
  });
};

export const concessionTypeDetail = data => {
  let queryString = data.id;
  return axios({
    url: "/api/concessionType/detail/" + queryString,
    method: "get",
    data: { data }
  });
};

export const concessionUploadPDF = data => {
  return axios({
    url: "/api/cinema/uploadPdf",
    method: "uploadfile",
    data: {
      data,
    },
  });
}

export const setConcessionPDFUrl = (data, loading = true,  isDefaultAlertTips = true) => {
  return axios({
    url: `/api/cinema/updateConcessionMenuPdf/${data.cinemaId}?path=${data.path}`,
    method: "put",
    data: {
      loading,
      isDefaultAlertTips
    },
  });
}
export const createConcessionForNew = data => {
  return axios({
    url: "/api/concessionType/create-multiple",
    method: "post",
    data: { data }
  });
};
